/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StatusCell/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StatusCell({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/StatusCell"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let receivableValueData = fromData.useDataFormat({ viewPath,
context: 'receivable',
format: fromHelpers.isPending,
})
let receivableBalanceAmountValueData = fromData.useDataFormat({ viewPath,
context: 'receivable',
path: 'balance_amount',
format: fromHelpers.isPaid,
})
let receivableValueData1 = fromData.useDataFormat({ viewPath,
context: 'receivable',
format: fromHelpers.isClaimPaid,
})
let receivableValueData2 = fromData.useDataFormat({ viewPath,
context: 'receivable',
format: fromHelpers.isClaimOnHold,
})
let receivableValueData3 = fromData.useDataFormat({ viewPath,
context: 'receivable',
format: fromHelpers.isClaimRejected,
})
let receivableValueData4 = fromData.useDataFormat({ viewPath,
context: 'receivable',
format: fromHelpers.isDue,
})
let receivableValueData5 = fromData.useDataFormat({ viewPath,
context: 'receivable',
format: fromHelpers.getStatus,
})
  return (<React.Fragment
>
<div
  data-testid="StatusCell.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2qlenm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 style="filled"
 display="inline-block"
 alignSelf="center"
 marginTop={0}
 type={receivableValueData ? "orange" : receivableBalanceAmountValueData ? "green" : receivableValueData1 ? "green" : receivableValueData2 ? "orange" : receivableValueData3 ? "red" : receivableValueData4 ? "red" : "grey"}
 data={receivableValueData ? "receivable.balance_amount" : receivableBalanceAmountValueData ? "receivable" : receivableValueData1 ? "receivable" : receivableValueData2 ? "receivable" : receivableValueData3 ? "receivable" : "receivable"}
 format={receivableBalanceAmountValueData ? "helpers.js isPaid" : receivableValueData1 ? "helpers.js isClaimPaid" : receivableValueData2 ? "helpers.js isClaimOnHold" : receivableValueData3 ? "helpers.js isClaimRejected" : receivableValueData4 ? "helpers.js isDue" : "helpers.js isPending"}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="receivable"
 format="helpers.js getStatus"
 text={receivableValueData5}
/>
)}
</TysiaTag>
</div>
{children}
</React.Fragment>)
}